import React from 'react';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion as MUIAccordion, AccordionSummary, AccordionDetails } from '@material-ui/core';

import Text from '../typography/typgraphy';
import { IAccordianProps } from '../../constants/commonTypes';


const Accordian = (props: IAccordianProps) => {
  const { summary, children, summaryStyle, ...rest } = props
  return (
    <MUIAccordion {...rest}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Text className={summaryStyle}>{summary}</Text>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </MUIAccordion>
  )
}

Accordian.propTypes = {
  summary: PropTypes.string,
  children: PropTypes.node,
  summaryStyle: PropTypes.string,
}

Accordian.defaultProps = {
  summary: "",
  children: null,
  summaryStyle: "",
}

export default Accordian;